/**
 * Paths the service accepts in an `update_mask`. Anything else — `id`,
 * `dsp_info`, `created_by`, `data_sources`, the research fields — is read-only,
 * and the service rejects the whole request if the mask names even one of
 * them. Mirrors the whitelist in the seller service's `validateFieldMask`.
 *
 * A key absent from this list is dropped from the derived mask **silently**.
 * That is deliberate for read-only fields, which callers routinely hand over
 * as part of a whole loaded profile. The cost is that if the service makes a
 * new field updatable and this list is not extended with it, editing that
 * field returns 200 from a PATCH that did not persist it. Nothing across the
 * language boundary catches that, so start here when an edit goes missing.
 */
export const ADVERTISER_PROFILE_UPDATABLE_PATHS = [
    "name",
    "description",
    "logo_url",
    "insights_blurb",
    "confidence_score",
    "locations",
    "industries",
    "competitors",
    "products_services",
    "third_party_info",
    "contact.email",
    "contact.phone",
    "contact.website"
];
const UPDATABLE_PATHS = new Set(ADVERTISER_PROFILE_UPDATABLE_PATHS);
export const isAdvertiserProfileUpdatablePath = (path) => UPDATABLE_PATHS.has(path);
//# sourceMappingURL=types.js.map